module.exports = __webpack_public_path__ + "img/straight_line_icon.2512028d.svg";